import React, { useEffect, useRef, useState } from 'react';
import * as styles from './index.module.less';
import { PublicArrowRightTail, PublicClose } from 'notta-web-icon';
import { useCountDown } from 'ahooks';
import BannerDecoRight from '@/images/layout/banner-deco-right.svg';
import BannerDecoLeft from '@/images/layout/banner-deco-left.svg';
interface IProp {
  type: 'en' | 'ja';
  className?: string;
  onClose?: (e) => void;
}

const BANNER_CONTENT = {
  en: {
    title: (
      <div className={styles.content_en}>
        🎁 45%OFF on Pro plan. Grab{' '}
        <a
          href="https://app.notta.ai/?from=official&language=en&pay_cycle=year&stripe_id=1051&seats=1&subscribe_type=pro"
          target="_blank"
          rel="noreferrer"
        >
          your best deal
        </a>{' '}
        of the year. Promo Code: MR45.
      </div>
    ),
  },
  ja: {
    title: (
      <div className={styles.content_ja}>
        ＼<span className={styles.icon}>🎅🏻🎄</span>クリスマス＆
        <wbr />
        年末感謝
        <wbr />
        キャンペーン／ <wbr />
        プレミアムプラン
        <wbr />
        45%OFF
        <wbr />の<wbr />
        特典
        <wbr />を<wbr />
        GETしよう！
        <wbr />
        プロモコード：MR45
      </div>
    ),
  },
};

const CTA_BTN = {
  en: {
    label: 'Get Pro',
    link: 'https://app.notta.ai/?from=official&language=en&pay_cycle=year&stripe_id=1024&seats=1&subscribe_type=pro',
  },
  ja: {
    label: '今すぐ始める',
    link: 'https://app.notta.ai/?from=official&language=ja&pay_cycle=year&stripe_id=1051&seats=1&subscribe_type=pro',
  },
};

const TIME_SUFFIX = {
  en: {
    day: 'Days',
    hr: 'Hrs',
    min: 'Mins',
    sec: 'Secs',
  },
  ja: {
    day: '日',
    hr: '時',
    min: '分',
    sec: '秒',
  },
};

const TARGET_DATE = {
  en: '2023-12-29T00:00:00-05:00',
  ja: '2023-12-29T00:00:00+09:00',
};

const NumberWrapper = ({ number, suffix }: { number: number; suffix: string }) => {
  return (
    <div className={styles.number_wrapper}>
      <span className={styles.time_number_text}>{number.toFixed().padStart(2, '0')}</span>
      <span className={styles.time_suffix}>{suffix}</span>
    </div>
  );
};

const DiscountBanner = ({ type, className, onClose }: IProp) => {
  const [restDay, setRestDay] = useState(0);
  const [restHours, setRestHours] = useState(0);
  const [restMin, setRestMin] = useState(0);
  const [restSeconds, setRestSeconds] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  const [, formattedRes] = useCountDown({
    targetDate: new Date(TARGET_DATE[type]).getTime(),
    onEnd: () => {
      setIsEnd(true);
    },
  });
  const { days, hours, minutes, seconds } = formattedRes;
  const snowCanvasRef = useRef<HTMLCanvasElement>();
  const outerRef = useRef<HTMLDivElement>();

  const handleBannerClick = () => {
    // window.open(
    //   'https://app.notta.ai/?from=official&language=en&pay_cycle=year&stripe_id=1051&seats=1&subscribe_type=pro',
    //   '_blank',
    // );
  };

  useEffect(() => {
    setRestDay(days);
    setRestHours(hours);
    setRestMin(minutes);
    setRestSeconds(seconds);
  }, [days, hours, minutes, seconds]);

  useEffect(() => {
    // 获取Canvas元素和2D上下文
    const canvas = snowCanvasRef.current;
    const ctx = canvas.getContext('2d');

    handleChangeCanvasSize();

    // 雪花数组
    const snowflakes = [];

    // 创建雪花对象
    function Snowflake(x, y, radius) {
      this.x = x;
      this.y = y;
      this.radius = radius;
      this.speed = Math.random() + 1; // 随机速度
    }

    // 绘制雪花
    Snowflake.prototype.draw = function () {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = 'white';
      ctx.fill();
      ctx.closePath();
    };

    // 更新雪花的位置
    Snowflake.prototype.update = function () {
      this.y += this.speed;

      // 重新设置雪花位置，使其在顶部重新出现
      if (this.y > canvas.height) {
        this.y = 0;
        this.x = Math.random() * canvas.width;
      }
    };

    // 创建雪花
    function createSnowflakes(count) {
      for (let i = 0; i < count; i++) {
        const x = Math.random() * canvas.width;
        const y = Math.random() * canvas.height;
        const radius = Math.random() * 3 + 1;
        snowflakes.push(new Snowflake(x, y, radius));
      }
    }

    // 动画循环
    function animate() {
      // 清空Canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 更新和绘制每个雪花
      for (let i = 0; i < snowflakes.length; i++) {
        snowflakes[i].update();
        snowflakes[i].draw();
      }

      // 递归调用动画函数
      requestAnimationFrame(animate);
    }

    // 初始化
    createSnowflakes(60);
    animate(); // 启动动画
  }, []);

  const handleChangeCanvasSize = () => {
    const outerRect = outerRef.current.getBoundingClientRect();
    const canvas = snowCanvasRef.current;

    // 设置Canvas大小
    canvas.width = outerRect.width;
    canvas.height = outerRect.height;
  };

  useEffect(() => {
    window.addEventListener('resize', handleChangeCanvasSize);

    return () => {
      window.removeEventListener('resize', handleChangeCanvasSize);
    };
  }, []);
  return (
    <div className={`${styles.outer} ${isEnd && styles.is_end}`} ref={outerRef}>
      <canvas id="snowCanvas" className={styles.snow_canvas} ref={snowCanvasRef}></canvas>
      <div className={styles.deco_line}></div>
      <div className={`${className} ${styles.wrapper}`} onClick={handleBannerClick}>
        <div className={`${styles.inner} ${type === 'en' ? styles.en : ''}`}>
          <div className={styles.content_btn_wrapper}>
            {/* 倒计时 & 文案 */}
            <div className={styles.count_down_content_wrapper}>
              <div className={`${styles.count_down_part} ${styles[type]}`}>
                <NumberWrapper number={restDay} suffix={TIME_SUFFIX[type].day} />
                <div className={styles.time_number_text}>:</div>
                <NumberWrapper number={restHours} suffix={TIME_SUFFIX[type].hr} />
                <div className={styles.time_number_text}>:</div>
                <NumberWrapper number={restMin} suffix={TIME_SUFFIX[type].min} />
                <div className={styles.time_number_text}>:</div>
                <NumberWrapper number={restSeconds} suffix={TIME_SUFFIX[type].sec} />
              </div>
              <div className={styles.content_wrapper}>
                {type === 'en' && (
                  <img className={styles.content_deco} src={BannerDecoLeft} alt="" aria-hidden="true" />
                )}
                {BANNER_CONTENT[type].title}
                {type === 'en' && (
                  <img className={styles.content_deco} src={BannerDecoRight} alt="" aria-hidden="true" />
                )}
              </div>
            </div>
            {/* btn */}
            <a href={CTA_BTN[type].link} target="_blank" rel="noreferrer">
              <button className={styles.buy_now_btn}>
                {CTA_BTN[type].label} <PublicArrowRightTail />
              </button>
            </a>
          </div>
          <button className={styles.close_btn} onClick={onClose}>
            <PublicClose />
          </button>
        </div>
      </div>
    </div>
  );
};
export default DiscountBanner;
